import {
  FETCH_CART_ITEMS,
  FETCH_CART_ITEMS_SUCCESS,
  FETCH_CART_ITEMS_ERROR,
  UPDATE_CART_ITEM,
  UPDATE_CART_ITEM_SUCCESS,
  UPDATE_CART_ITEM_ERROR,
  REMOVE_CART_ITEM,
  REMOVE_CART_ITEM_SUCCESS,
  REMOVE_CART_ITEM_ERROR,
  FETCH_CART_COUNT,
  FETCH_CART_COUNT_SUCCESS,
  FETCH_CART_COUNT_ERROR,
  MOVE_TO_WISHLIST,
  MOVE_TO_WISHLIST_SUCCESS,
  MOVE_TO_WISHLIST_ERROR,
} from '../actionTypes';

export const fetchCartItems = (data) => ({
  type: FETCH_CART_ITEMS,
  payload: data,
});

export const fetchCartItemsSuccess = (user) => ({
  type: FETCH_CART_ITEMS_SUCCESS,
  payload: user,
});

export const fetchCartItemsError = (message) => ({
  type: FETCH_CART_ITEMS_ERROR,
  payload: message,
});

export const updateCartItem = (data) => ({
  type: UPDATE_CART_ITEM,
  payload: data,
});

export const updateCartItemSuccess = (user) => ({
  type: UPDATE_CART_ITEM_SUCCESS,
  payload: user,
});

export const updateCartItemError = (message) => ({
  type: UPDATE_CART_ITEM_ERROR,
  payload: message,
});

export const removeCartItem = (data) => ({
  type: REMOVE_CART_ITEM,
  payload: data,
});

export const removeCartItemSuccess = (user) => ({
  type: REMOVE_CART_ITEM_SUCCESS,
  payload: user,
});

export const removeCartItemError = (message) => ({
  type: REMOVE_CART_ITEM_ERROR,
  payload: message,
});

export const fetchCartCount = (data) => ({
  type: FETCH_CART_COUNT,
  payload: data,
});

export const fetchCartCountSuccess = (user) => ({
  type: FETCH_CART_COUNT_SUCCESS,
  payload: user,
});

export const fetchCartCountError = (message) => ({
  type: FETCH_CART_COUNT_ERROR,
  payload: message,
});

export const moveToWishlist = (data) => ({
  type: MOVE_TO_WISHLIST,
  payload: data,
});

export const moveToWishlistSuccess = (user) => ({
  type: MOVE_TO_WISHLIST_SUCCESS,
  payload: user,
});

export const moveToWishlistError = (message) => ({
  type: MOVE_TO_WISHLIST_ERROR,
  payload: message,
});
